var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.address.type.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address.street)+" "+_vm._s(_vm.address.house_number))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address.zipcode)+" "+_vm._s(_vm.address.city))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address.country.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }